import { render } from "./ServicesSection.vue?vue&type=template&id=79294cd8&scoped=true"
import script from "./ServicesSection.vue?vue&type=script&lang=js"
export * from "./ServicesSection.vue?vue&type=script&lang=js"

import "./ServicesSection.vue?vue&type=style&index=0&id=79294cd8&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79294cd8"]])

export default __exports__